// src/services/signalCrypto.js — identique à la version précédente

import { signalStore } from './signalStore';


export async function aesDecryptBytes(ciphertext, key, iv) {
  const cryptoKey = await crypto.subtle.importKey(
    'raw',
    key,
    { name: 'AES-GCM', length: 256 },
    false,
    ['decrypt']
  );

  const decrypted = await crypto.subtle.decrypt(
    { name: 'AES-GCM', iv },
    cryptoKey,
    ciphertext
  );

  return new Uint8Array(decrypted);
}

export async function aesDecryptText(ciphertext, key, iv) {
  const decrypted = await aesDecryptBytes(
    ciphertext,
    key,
    iv
  );

  return new TextDecoder().decode(decrypted);
}

export async function aesEncryptBytes(plaintext) {
  const key = crypto.getRandomValues(new Uint8Array(32));
  const iv = crypto.getRandomValues(new Uint8Array(12));

  const cryptoKey = await crypto.subtle.importKey(
    'raw',
    key,
    { name: 'AES-GCM', length: 256 },
    false,
    ['encrypt']
  );

  let data;

  if (plaintext instanceof ArrayBuffer) {
    data = new Uint8Array(plaintext);
  } else if (plaintext instanceof Uint8Array) {
    data = plaintext;
  } else {
    throw new Error(
      `aesEncryptBytes: type invalide : ${
        plaintext?.constructor?.name
      }`
    );
  }

  const encrypted = await crypto.subtle.encrypt(
    {
      name: 'AES-GCM',
      iv
    },
    cryptoKey,
    data
  );

  return {
    ciphertext: new Uint8Array(encrypted),
    iv,
    key
  };
}

export async function aesEncryptText(plaintext) {
  if (typeof plaintext !== 'string') {
    throw new Error(
      `aesEncryptText: plaintext doit être une string, reçu ${
        plaintext?.constructor?.name
      }`
    );
  }

  return aesEncryptBytes(
    new TextEncoder().encode(plaintext)
  );
}
let _selfKeyCache = null;

export async function getSelfEncryptKey() {
  if (_selfKeyCache) return _selfKeyCache;

  const identityKeyPair =
    await signalStore.get('identityKey');

  if (!identityKeyPair?.privKey) {
    throw new Error('Clé d\'identité Signal non trouvée');
  }

  const pubB64 = btoa(
    String.fromCharCode(
      ...new Uint8Array(identityKeyPair.pubKey)
    )
  );

  

  const privKeyBytes =
    new Uint8Array(identityKeyPair.privKey);

  const hash =
    await crypto.subtle.digest(
      'SHA-256',
      privKeyBytes
    );

  _selfKeyCache =
    await crypto.subtle.importKey(
      'raw',
      hash,
      {
        name: 'AES-GCM',
        length: 256
      },
      false,
      ['encrypt', 'decrypt']
    );

  return _selfKeyCache;
}
export async function selfEncryptKey(aesKey) {
  const selfKey = await getSelfEncryptKey();
  const iv = crypto.getRandomValues(new Uint8Array(12));
  const encrypted = await crypto.subtle.encrypt(
    { name: 'AES-GCM', iv }, selfKey, aesKey
  );
  return { encrypted: new Uint8Array(encrypted), iv };
}

export async function selfDecryptKey(encryptedKey, iv) {
  const selfKey = await getSelfEncryptKey();
  const decrypted = await crypto.subtle.decrypt(
    { name: 'AES-GCM', iv }, selfKey, encryptedKey
  );
  return new Uint8Array(decrypted);
}

export function bufferToBase64(buffer) {
  const bytes = buffer instanceof Uint8Array ? buffer : new Uint8Array(buffer);
  let binary = '';
  for (let i = 0; i < bytes.length; i++) binary += String.fromCharCode(bytes[i]);
  return btoa(binary);
}

export function base64ToBuffer(base64) {
  try {
    const binary = atob(base64);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
    return bytes;
  } catch (err) {
    console.error('base64ToBuffer a échoué sur:', JSON.stringify(base64), 'longueur:', base64?.length);
    throw err;
  }
}

export function toArrayBuffer(input) {
  if (input instanceof ArrayBuffer) return input;
  if (ArrayBuffer.isView(input)) {
    // Copie propre, sans byteOffset hérité
    return input.buffer.slice(input.byteOffset, input.byteOffset + input.byteLength);
  }
  throw new Error('toArrayBuffer: format non reconnu');
}